import React, {useState, useEffect, useMemo} from "react";
import { MaterialSymbol } from "react-material-symbols";
import "./style.scss";
import { popinfo } from "component/Fancybox/Fancybox";
import api from "api";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import stateMap from "store/stateMap";
import { Splide, SplideSlide } from "@splidejs/react-splide";

const ComponentSurvey = ({survey, onClickCTA}) => {
    return (
        <div className="component-survey-item">
            {
              survey.IsPublished === 0 && <span className="survey-is-draft">DRAFT</span>
            }
            <MaterialSymbol className="survey-icon"  icon="rate_review"/>
            <h2 className="survey-title text-md font-semibold">{survey.SurveyTitle}</h2>
            <div className="text-sm survey-desc leading-text mb-md">
                {survey.SurveyDescription}
            </div>
            <ul className="survey-metas text-sm">
                {/* {
                  survey.AvgDuration > 0 && 
                  <li className="survey-meta">
                      <MaterialSymbol className="survey-meta--icon" icon="clock_loader_80"/>
                      <span className="survey-meta--label  leading-text">
                          {survey.AvgDuration >= 60 
                              ? `About ${Math.round(survey.AvgDuration/60)} hour${Math.round(survey.AvgDuration/60) > 1 ? 's' : ''}`
                              : survey.AvgDuration > 1 
                                  ? `About ${Math.round(survey.AvgDuration)} minutes`
                                  : 'Less than a minute'}
                      </span>
                  </li>
                } */}
                {
                  survey.SurveyEngineType === 'Internal' &&
                  <li className="survey-meta">
                      <MaterialSymbol className="survey-meta--icon" icon="group"/>
                      <span className="survey-meta--label  leading-text"><span className="font-semibold">{survey.TotalResponse}</span>{survey.Quota > 0 && `/${survey.Quota}`} Respondens</span>
                  </li>
                }
                {
                  survey.SurveyEngineType === 'External' && survey.TotalView > 0 &&
                  <li className="survey-meta">
                      <MaterialSymbol className="survey-meta--icon" icon="group"/>
                      <span className="survey-meta--label  leading-text"><span className="font-semibold">{survey.TotalView}</span> Views</span>
                  </li>
                }
                {
                  survey.SATPoint > 0 &&
                  <li className="survey-meta">
                      <MaterialSymbol className="survey-meta--icon" icon="sell"/>
                      <span className="survey-meta--label  leading-text"><span className="font-semibold">{survey.SATPoint}</span> SAT Points upon survey completion</span>
                  </li>
                }
            </ul>
            {
              (
                (
                  survey.SurveyEngineType === 'Internal' && (survey.Quota === 0 || survey.TotalResponse < survey.Quota)
                ) 
                || survey.SurveyEngineType === 'External'
              ) && 
              <button className={`btn btn-participate ${survey.IsPublished === 0 ? 'btn-grey' : 'btn-orange'}`} onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  if(survey.IsPublished === 1)
                  {
                    onClickCTA(survey);
                  }
              }}>{survey.IsPublished === 0 ? 'Closed' : 'Participate'}</button>
            }
            {
              survey.SurveyEngineType === 'Internal' && survey.Quota > 0 && survey.TotalResponse >= survey.Quota &&
              <span className="btn btn-grey btn-participate">Closed</span>
            }
        </div>
    )
};

const ComponentSurveyRunner = connect(stateMap)(({ surveyID, onComplete, auth, initiative, isPreview }) => {
  // State declarations
  const [loading, setLoading] = useState(true);
  const [surveyData, setSurveyData] = useState([]);
  const [survey, setSurvey] = useState({});
  const [startSurveyTime, setStartSurveyTime] = useState(() => Date.now());
  const [alreadyResponse, setAlreadyResponse] = useState(false);
  const [campuses, setCampuses] = useState([]);
  const [degrees, setDegree] = useState([]);
  const [programs, setPrograms] = useState([]);
  const [filteredPrograms, setFilteredPrograms] = useState([]);
  const [selectedCampus, setSelectedCampus] = useState(false);
  const [selectedDegree, setSelectedDegree] = useState(false);
  const [selectedProgram, setSelectedProgram] = useState(false);
  const [isFYPParticipant, setIsFYPParticipant] = useState(null);
  const [confirmNotStudent, setConfirmNotStudent] = useState(false);
  const [answers, setAnswers] = useState({});
  const [surveyEnded, setSurveyEnded] = useState(false);
  const [forceUpdate, setForceUpdate] = useState(false);

  // Filter programs (tetap sama)
  useEffect(() => {
    setFilteredPrograms(programs.filter(program => 
      (!selectedCampus || program.Campus === selectedCampus) && 
      (!selectedDegree || program.ProgramLevel === selectedDegree)
    ));
  }, [selectedCampus, selectedDegree, programs]);

  // Load survey data (tetap sama)
  useEffect(() => {
    if (!surveyID || !auth.user) return;
    setLoading(true);
    
    Promise.all([
      api("/Survey", "get", { id: surveyID, posts_per_page: 1, include_body: true, include_draft: isPreview ? 1 : 0 }, isPreview ? 'Bearer ' + auth.token : false),
      api("/SurveyResponse", "get", { survey_id: surveyID, user_id: auth.user.UserID }, 'Bearer ' + auth.token),
      api("/SurveyGetMasterProgram", "get", {}, 'Bearer ' + auth.token),
      api('/SurveyAddView', 'post', {survey_id: surveyID}, 'Bearer ' + auth.token)
    ])
    .then(([ResponseSurvey, ResponseFilled, ResponseMasterProgram]) => {
      setLoading(false);
      if (ResponseSurvey.survey?.length) {
        setSurveyData(ResponseSurvey.survey[0].SurveyBody || []);
        setSurvey(ResponseSurvey.survey[0]);
        setStartSurveyTime(Date.now() + (7 * 60 * 60 * 1000)); // Add 7 hours to current time
        setDegree(ResponseMasterProgram.program_levels);
        setCampuses(ResponseMasterProgram.campuses);
        setPrograms(Object.values(ResponseMasterProgram.programs));
      } else {
        popinfo("error", "Survey Not Found", "Cannot find the survey.");
      }

      if (ResponseFilled.response.length > 0 && ResponseFilled.response[0].ResponseAnswer) {
        setAlreadyResponse(true);
      }
    })
    .catch(err => {
      setLoading(false);
      popinfo("error", "Survey Service Error", err);
    });
  }, [surveyID, auth.user]);

  const handleChange = (id, val) => {
    setAnswers(prev => ({ ...prev, [id]: val }));
    // Hapus pengecekan branching di sini
  };

  const handleSubmit = e => {
    e.preventDefault();
    e.stopPropagation();

    if (survey.IsPublished === 0) {
      onComplete(answers);
      return;
    }

    if(isPreview)
    {
      onComplete(answers);
      return;
    }

    if (!confirmNotStudent) {
      if (!selectedCampus || !selectedDegree || !selectedProgram || isFYPParticipant === null) {
        popinfo("error", "Required Information", "Please select your campus, degree, program and FYP status");
        return;
      }
    }

    // Pindahkan pengecekan branching ke sini, tepat sebelum submit
    const shouldEndSurvey = checkForSurveyEndBranching();
    if (shouldEndSurvey) {
      setSurveyEnded(true);
      // Tetap lanjutkan ke proses submit
    }

    const SavingResponse = popinfo('preloader', 'Please Wait', 'Saving Your Answer');

    api('/SurveyResponse', 'post', {
      SurveyID: surveyID,
      ResponseAnswer: answers,
      StudentInformation_Campus: confirmNotStudent ? '' : selectedCampus,
      StudentInformation_Degree: confirmNotStudent ? '' : selectedDegree,
      StudentInformation_Program: confirmNotStudent ? '' : selectedProgram,
      StudentInformation_IsFYP: confirmNotStudent ? '' : isFYPParticipant,
      TotalPreview: 0,
      ResponseStartTime: startSurveyTime,
      DeviceType: navigator.userAgent,
    }, 'Bearer ' + auth.token)
    .then(() => {
      popinfo('ok', 'Success', 'Your answer has been recorded, Thank you for participating', {}, SavingResponse);
      onComplete(answers);
      setAlreadyResponse(true);
    })
    .catch(err => {
      popinfo('error', 'Ooopss', err, {}, SavingResponse);
    });
  };

  // Fungsi checkForSurveyEndBranching tetap sama
  const checkForSurveyEndBranching = () => {
    for (const section of surveyData) {
      for (const question of section.questions) {
        if (answers[question.id] && question.branchTo?.targetType === "end") {
          return true;
        }
        
        if (question.type === "multiple_choice" && answers[question.id]) {
          const selectedOption = question.options.find(opt => opt.label === answers[question.id]);
          if (selectedOption?.branchTo?.targetType === "end") {
            return true;
          }
        }
      }
    }
    return false;
  };

  // Modifikasi getVisibleQuestions untuk tidak otomatis mengakhiri survey
  const getVisibleQuestions = () => {
    const visibleList = [];
    let activeSection = null;
    const MAX_ITERATIONS = 1000;
    let iterationCount = 0;
    let shouldStop = false; // Flag untuk menghentikan render pertanyaan selanjutnya
  
    const findQuestionInSection = (section, questionId) => {
      return section.questions.findIndex(q => q.id === questionId);
    };
  
    const findSectionById = (sectionId) => {
      return surveyData.findIndex(s => s.id === sectionId);
    };
  
    const hasActiveBranching = (question) => {
      if (question.branchTo?.targetType && question.branchTo.targetType !== null) {
        return true;
      }
      
      if (question.type === "multiple_choice" && question.options) {
        return question.options.some(opt => 
          opt.branchTo?.jumpToQuestionId || 
          opt.branchTo?.goToSectionId
        );
      }
      
      return false;
    };
  
    const getBranchTarget = (question, answer) => {
      if (!answer) return null;
  
      // Untuk multiple choice, cek branching di option
      if (question.type === "multiple_choice") {
        const selectedOption = question.options.find(opt => opt.label === answer);
        if (selectedOption?.branchTo) {
          if (selectedOption.branchTo.jumpToQuestionId) {
            return { type: "question", id: selectedOption.branchTo.jumpToQuestionId };
          }
          if (selectedOption.branchTo.goToSectionId) {
            return { type: "section", id: selectedOption.branchTo.goToSectionId };
          }
        }
      }
      
      // Cek branching di level question
      if (question.branchTo?.targetType) {
        if (question.branchTo.targetType === "question") {
          return { type: "question", id: question.branchTo.target };
        } else if (question.branchTo.targetType === "section") {
          return { type: "section", id: question.branchTo.target };
        } else if (question.branchTo.targetType === "end") {
          return { type: "end" };
        }
      }
      
      return null;
    };
  
    // Loop melalui setiap section
    for (let sectionIndex = 0; sectionIndex < surveyData.length && !shouldStop; sectionIndex++) {
      const section = surveyData[sectionIndex];
      const isActiveSection = activeSection === null;
      
      visibleList.push({ 
        type: "section", 
        section, 
        active: isActiveSection,
        preview: !isActiveSection 
      });
      
      if (isActiveSection) {
        activeSection = sectionIndex;
        let questionIndex = 0;
        const visitedQuestions = new Set();
        
        while (questionIndex < section.questions.length && iterationCount < MAX_ITERATIONS && !shouldStop) {
          iterationCount++;
          const question = section.questions[questionIndex];
          const visitKey = `${section.id}-${question.id}-${questionIndex}`;
          
          if (visitedQuestions.has(visitKey)) {
            console.warn(`Loop detected at question ${question.id}`);
            break;
          }
          visitedQuestions.add(visitKey);
          
          visibleList.push({ type: "question", question });
          
          const answer = answers[question.id];
          const hasBranching = hasActiveBranching(question);
          
          if (hasBranching && !answer) {
            // Jika ada branching tapi belum dijawab, berhenti di sini
            break;
          }
          
          if (answer && hasBranching) {
            const branchTarget = getBranchTarget(question, answer);
            
            if (branchTarget?.type === "question") {
              const targetIndex = findQuestionInSection(section, branchTarget.id);
              if (targetIndex >= 0) {
                questionIndex = targetIndex;
                continue;
              }
            } else if (branchTarget?.type === "section") {
              const targetSectionIndex = findSectionById(branchTarget.id);
              if (targetSectionIndex >= 0) {
                activeSection = null;
                sectionIndex = targetSectionIndex - 1; // -1 karena loop akan increment
                break;
              }
            } else if (branchTarget?.type === "end") {
              // Set flag untuk menghentikan render pertanyaan selanjutnya
              shouldStop = true;
              break;
            }
          }
          
          questionIndex++;
        }
        
        if (questionIndex >= section.questions.length) {
          activeSection = null; // Lanjut ke section berikutnya
        }
      }
    }
    
    return visibleList;
  };

  const visibleList = getVisibleQuestions();

  const DetectNotStudent = () => {
    return auth.user.UserEmail && auth.user.UserEmail.includes('@binus.edu');
  };

  if (loading) {
    return <div className="component-survey-runner">
      <div className="survey-question-body">
        <div className="skeleton"></div>
        <div className="skeleton mt-sm"></div>
        <div className="skeleton mt-md" style={{height : '100px'}}></div>

      </div>
    </div>
  }

  return (
    <form className="component-survey-runner generic-form" onSubmit={handleSubmit}>
      <div className="survey-runner-header">
        <MaterialSymbol icon="rate_review" className="survey-runner-header--icon" />
        <h2 className="text-md font-semibold mb-sm">{survey.SurveyTitle}</h2>
        <p className="leading-text text-sm">{survey.SurveyDescription}</p>
      </div>
      
      {((isPreview && initiative.access.membership?.MemberType === 'admin') ||
        (!isPreview && !alreadyResponse)) && (
        <>
          <hr/>
          <div className="survey-question-body">
            <div className={`student-master-section ${DetectNotStudent() ? '--probable-not-student' : ''}`}>
              {DetectNotStudent() && (
                <>
                  <div className="flex flex-wrap">
                    <label className="switch-button">
                      <input
                        type="checkbox"
                        checked={confirmNotStudent}
                        onChange={(e) => setConfirmNotStudent(e.target.checked)}
                      />
                      <span className="slider round"></span>
                    </label>
                    <div className="font-semibold">
                      &nbsp;Confirm I am not a student
                    </div>
                  </div>
                  <hr/>
                </>
              )}
              
              <div className="section-header">
                <h2 className="font-semibold">Informasi BINUSIAN</h2>
                <p className="leading-text text-sm mt-sm mb-md">Informasi dasar Anda yang akan digunakan untuk keperluan survey</p>
              </div>
              
              {!confirmNotStudent && (
                <>
                  <div className="form-group">
                    <label>Select Campus*</label>
                    <div className="fancy-select">
                      <select 
                        value={selectedCampus || ""} 
                        onChange={(e) => setSelectedCampus(e.target.value)}
                      >
                        <option value="">Select Campus</option>
                        {campuses.map(campus => (
                          <option key={campus} value={campus}>{campus}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  
                  <div className="form-group">
                    <label>Select Degree*</label>
                    <div className="fancy-select">
                      <select 
                        value={selectedDegree || ""} 
                        onChange={(e) => setSelectedDegree(e.target.value)}
                      >
                        <option value="">Select Degree</option>
                        {degrees.map(degree => (
                          <option key={degree} value={degree}>{degree}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  
                  <div className="form-group">
                    <label>Select Program*</label>
                    <div className="fancy-select">
                      <select 
                        value={selectedProgram || ""} 
                        onChange={(e) => setSelectedProgram(e.target.value)}
                      >
                        <option value="">Select Program</option>
                        {filteredPrograms.map(program => (
                          <option key={program.ProgramCode} value={program.ProgramCode}>
                            {program.ProgramName}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  
                  <div className="form-group">
                    <label>Apakah kamu sedang menjalani FYP?</label>
                    <div>
                      <label className="option-label">
                        <input
                          type="radio"
                          name="fyp_status"
                          checked={isFYPParticipant === true}
                          onChange={() => setIsFYPParticipant(true)}
                        />
                        <span>Ya</span>
                      </label>
                      <label className="option-label">
                        <input
                          type="radio"
                          name="fyp_status"
                          checked={isFYPParticipant === false}
                          onChange={() => setIsFYPParticipant(false)}
                        />
                        <span>Tidak</span>
                      </label>
                    </div>
                  </div>
                </>
              )}
            </div>

            {/* FIXED: Show survey ended message when appropriate */}
            {surveyEnded && (
              <div className="survey-end-notice" style={{
                background: '#e8f5e8',
                border: '1px solid #4caf50',
                borderRadius: '4px',
                padding: '15px',
                marginBottom: '20px',
                color: '#2e7d32'
              }}>
                <p className="font-semibold mb-2">Survey Completed!</p>
              </div>
            )}
            
            {visibleList.map((item, i) => {
              if (item.type === "section") {
                return (
                  !item.preview &&
                  <header 
                    key={`s-${item.section.id}`} 
                    className={`section-header ${item.preview ? 'section-preview' : 'section-active'}`}
                  >
                    <h2 className={`font-semibold leading-text ${item.preview ? 'text-gray-400' : ''}`}>
                      {item.section.title}
                      {item.preview && <hr/>}
                    </h2>
                    {item.section.description && !item.preview && (
                      <p className="leading-text text-sm mt-sm mb-md">{item.section.description}</p>
                    )}
                  </header>
                );
              }
              
              const { question } = item;
              return (
                <div key={question.id} className={`question-block ${question.required ? 'required' : ''}`}>
                  <p className="question-text leading-text mb-sm">
                    {question.images.length > 0 && (
                      <Splide
                        className="question-images mb-md"
                        options={{ perPage: 2, pagination: false, gap: "12px", arrowPath : ' ' }}
                      >
                        {question.images.map((img, idx) => (
                          <SplideSlide key={idx} className="image-box contain">
                            <img src={img.content} alt={img.name} />
                          </SplideSlide>
                        ))}
                      </Splide>
                    )}
                    {question.text}
                    {question.required && <span className="required-asterisk"> *</span>}
                  </p>

                  {question.type === "multiple_choice" && (
                    <div className="options">
                      {question.options.map(opt => (
                        <label key={opt.label} className="option-label">
                          <input
                            type="radio"
                            name={`q-${question.id}`}
                            value={opt.label}
                            checked={answers[question.id] === opt.label}
                            onChange={() => handleChange(question.id, opt.label)}
                          />
                          <span>{opt.label}</span>
                        </label>
                      ))}
                    </div>
                  )}

                  {question.type === "short_answer" && (
                    <input
                      type="text"
                      className="form-control text"
                      value={answers[question.id] || ""}
                      onChange={(e) => handleChange(question.id, e.target.value)}
                      placeholder="Your answer"
                    />
                  )}

                  {question.type === "long_answer" && (
                    <textarea
                      className="form-control textarea"
                      value={answers[question.id] || ""}
                      onChange={(e) => handleChange(question.id, e.target.value)}
                      placeholder="Your answer"
                      rows={4}
                    />
                  )}
                </div>
              );
            })}
          </div>
          
          {survey.IsPublished === 1 && (
            <>
              <hr/>
              <div className="survey-actions text-right">
                <button type="submit" className={`btn ${!isPreview ? 'btn-orange' : 'btn-grey'}`}>
                  Submit
                </button>
              </div>
            </>
          )}
        </>
      )}
      
      {!isPreview && survey.IsPublished === 1 && (alreadyResponse || (survey.Quota > 0 && survey.TotalResponse >= survey.Quota)) && (
        <div className="survey-question-body leading-text text-center" style={{background: '#c9c9c9'}}>
          {(survey.Quota > 0 && survey.TotalResponse >= survey.Quota) ? (
            <span>This survey has reached its maximum number of participants. <br/> Thank you for your interest!<br/></span>
          ) : (
            <span>Thank you for participating! You've already completed this survey.<br/></span>
          )}
          <br/>
          <Link to="../survey" className="btn btn-small btn-primary">Return to Survey List</Link>
        </div>
      )}
    </form>
  );
});

export {ComponentSurvey, ComponentSurveyRunner}